import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';

const LoadingModal = ({ 
loadingProgress
}) => {


return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-md ">
<div className="bg-white rounded-lg max-w-md w-full p-8">
<div className="text-center">
<div className="relative w-20 h-20 mx-auto mb-6">
<div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
<div
className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"
></div>
</div>

<h3 className="text-lg font-bold text-gray-900 mb-2">Preparing Your Interview</h3>

<div className="space-y-3 text-sm text-gray-600 mb-6">
{loadingProgress >= 20 && (
<div className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600" />
<span>Analyzing job requirements...</span>
</div>
)}
{loadingProgress >= 40 && (
<div className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600" />
<span>Researching company information...</span>
</div>
)}
{loadingProgress >= 60 && (
<div className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600" />
<span>Gathering industry insights...</span>
</div>
)}
{loadingProgress >= 80 && (
<div className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600" />
<span>Compiling interview questions...</span>
</div>
)}
{loadingProgress === 100 && (
<div className="flex items-center gap-2">
<CheckCircle className="w-4 h-4 text-green-600" />
<span>Generating preparation document...</span>
</div>
)}
</div>

<div className="w-full bg-gray-200 rounded-full h-2">
<div
className="bg-blue-600 h-2 rounded-full transition-all duration-500"
style={{ width: `${loadingProgress}%` }}
></div>
</div>
</div>
</div>
</div>
);
};

export default LoadingModal;